import { type AccountId, toAccountId } from '../../model/index.tsx';
import type { Response } from '../../rest/board/get/index.tsx';

export const transformUserAccountFromBoard = (baseUrl: string, response: Response): AccountId => {
	if (response && response.location && response.location.userAccountId) {
		return toAccountId(response.location.userAccountId);
	}

	throw new Error('Expected userAccountId to appear in the response');
};
